import React from "react"

import { TrianglePointSVG, CirclePointSVG } from "../../GraphSVGLayers/PointLayer"

export function PointMarker({ colour, pointSize = 2, pointModifier }) {
  if (pointModifier === "triangle") {
    return <TrianglePointSVG pointSize={pointSize} cx={0} cy={0} colour={colour} />
  } else {
    return <CirclePointSVG pointSize={pointSize} cx={0} cy={0} colour={colour} />
  }
}

export function LineMarker({ colour, strokeWidth = 3, strokeModifier }) {
  return (
    <line
      x1={-8}
      y1={0}
      x2={8}
      y2={0}
      stroke={colour}
      strokeDasharray={strokeModifier === "dashed" ? 4 : 0}
      strokeWidth={strokeModifier === "dashed" ? 1 : strokeWidth}
      fill="none"
    />
  )
}

export function LinesPointsMarker(props) {
  return (
    <>
      <PointMarker {...{ pointSize: 2, ...props }} />
      <LineMarker {...{ strokeWidth: 1, ...props }} />
    </>
  )
}

export function BoxMarker({ colour }) {
  return <rect width={5} height={5} fill={colour} />
}
